module.exports = __webpack_public_path__ + "static/media/notifstomention.11834071.gif";